import React from 'react'
import PropTypes from 'prop-types'
import { Colours, Sizes } from '../../style_helpers'

const AddIcon = (props) => {
  return (
    <svg style={props.style} width={props.width} height={props.height} viewBox='0 0 19 19' xmlns='http://www.w3.org/2000/svg'>
      <path d='M18.27 7.94h-6.99V1H7.5v6.95h-7v3.76h7v6.95h3.78V11.7h6.99z' fill={props.colour} fillRule='evenodd' />
    </svg>
  )
}

AddIcon.propTypes = {
  colour: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object
}

AddIcon.defaultProps = {
  colour: Colours('white', '300'),
  height: Sizes(1),
  width: Sizes(1),
  style: {}
}

export default AddIcon
